module.exports = "https://coursera_assets.s3.amazonaws.com/images/0c955394addc7e1eb7b00de45ad8557a.svg";